<template>
    <el-dialog class="dialog" :visible="dialogs.programs" :customClass="createEntity ? 'dialog_programs is-expanded' : 'dialog_programs'" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()" @open="handleOpen">
        <div class="dialog-programs dialog__inner">
            <div class="dialog-programs__column dialog-programs__column_aside">
                <div slot="title" class="dialog__head dialog__head_second">
                    <div class="dialog__head-inner">
                        <h2 class="dialog__title">{{ !orkInfo.editable ? 'Список образовательных программ' : 'Укажите соответствующую образовательную программу' }}</h2>
                    </div>
                </div>

                <button v-if="mode === 'qualification' && !read" type="button" class="btn btn_action-second btn_full mb-16" :disabled="createEntity" @click="createProgram">
                    Добавить новую программу
                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>

                <div v-if="programsByQualification.length === 0" style="text-align: center; color: #e2e2e2;">
                  Нет образовательных программ
                </div>

                <form action="#" @submit.prevent="submitSelected">
                    <div class="programs-list programs-list_vertical dialog-programs__programs-list">

                        <div class="programs-list__inner">
                            <el-checkbox-group v-model="selection">
                                <div class="programs-list__item" v-for="item in !orkInfo.editable ? programsByQualification.filter(el => selection.includes(el.id)) : programsByQualification" :key="item.id" @click="editProgram(item)">
                                    <div class="programs-list__content">
                                        <div class="programs-list__content-item programs-list__content-item_main">
                                            <span class="programs-list__checkbox-wrap">
                                                <el-checkbox v-if="orkInfo.editable" class="programs-list__checkbox" :label="item.id" />
                                                
                                                <span class="programs-list__text" v-if="mode === 'qualification'" v-html="item.name"></span>
                                                <span class="programs-list__text" :class="{ 'pl-0': orkInfo.editable }" v-if="mode === 'interrelations'" v-html="item.name"></span>
                                            </span>
                                        </div>

                                        <div class="programs-list__content-item" v-if="mode === 'qualification' && !read" >
                                            <div class="programs-list__extra" v-if="!item.external">
                                                <selector-btn :options="accordionOptionsForBtn" :params="{ id: item.id }" @clickOnItem="callback"></selector-btn>
                                            </div>
                                        
                                            <div class="programs-list__extra" v-if="item.external">
                                                <icon-base viewBox="0 0 21 20" class="programs-list__cloud">
                                                    <icon-cloud />
                                                </icon-base>
                                            </div>
                                        </div>
                                    </div>

                                    <footer class="programs-list__footer">
                                        Повышение квалификации

<!--                                        <icon-base viewBox="0 0 8 14" class="programs-list__more">-->
<!--                                            <icon-arrow-right />-->
<!--                                        </icon-base>-->
                                    </footer>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>

                    <footer class="dialog-programs__footer">
                        <button v-if="orkInfo.editable" type="submit" class="btn btn_action ml-auto">
                            Добавить выбранные программы
                        </button>
                    </footer>
                </form>
            </div>

            <div class="dialog-programs__column dialog-programs__column_main" :class="{ 'is-active': createEntity }">
                <div class="program">
                    <form @submit.prevent="createItem">
                        <header class="program__head">
                            <h2 class="dialog__title">Новая образовательная программа</h2>
                        </header>

                        <div class="program__content">
                            <section class="program__section">
                                <h2 class="program__title">Основная информация</h2>

                                <input type="text" name="name" class="input" placeholder="Название" required>

                                <textarea name="description" class="textarea mt-8" placeholder="Краткое описание"></textarea>

                                <v-select class="select mt-8" placeholder="Форма обучения" label="name" name="education_form_id" v-model="select" :clearable="false" :options="educationForms">
                                    <template #search="{attributes, events}">
                                        <input
                                            class="vs__search"
                                            v-bind="attributes"
                                            v-on="events"
                                            :required="!select"
                                        />
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        {{ SELECT_NOT_FOUND }}
                                    </template>
                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                                    </template>
                                </v-select>
                            </section>

                            <section class="program__section">
                                <h2 class="program__title">Контакты организации</h2>

                                <h4>Название организации</h4>

                                <div class="contacts">
                                    <div class="contacts__row">
                                        <div class="contacts__item">
                                            <input type="text" name="contact_name" class="input" placeholder="Название организации" required>
                                        </div>

                                        <div class="contacts__item">
                                            <masked-input name="contact_phone" mask="\+\7 (111) 111-11-11" class="input" placeholder="Телефон" required />
                                        </div>
                                    </div>
                                    <div class="contacts__row">
                                        <div class="contacts__item">
                                            <input type="text" name="contact_address" class="input" placeholder="Адрес организации" required>
                                        </div>

                                        <div class="contacts__item">
                                            <input type="text" name="contact_link" class="input" placeholder="Ссылка на сайт" required>
                                        </div>
                                    </div>
                                    <div class="contacts__row">
                                        <div class="contacts__item">
                                            <input type="text" name="program_link" class="input" placeholder="Ссылка на детальную страницу о программе">
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        <footer class="dialog-programs__footer">
                            <button type="submit" class="btn btn_primary ml-auto">
                                Добавить программу
                            </button>
                        </footer>
                    </form>
                </div>
            </div>

            <div class="dialog-programs__column dialog-programs__column_main" :class="{ 'is-active': activeProgram && showItem }" v-if="activeProgram">
                <div v-if="activeProgram.external">
                    <header class="program__head">
                        <h2 class="dialog__title">Образовательная программа</h2>
                    </header>

                    <div class="program__content">
                        <section class="program__section">
                            <h2 class="program__title">Основная информация</h2>

                            <span class="input" v-html="activeProgram.name"></span>

                            <span class="textarea mt-8" v-html="activeProgram.description" v-if="activeProgram.description"></span>

                            <span class="input mt-8" v-html="editSelect.name"></span>
                        </section>

                        <section class="program__section">
                            <h2 class="program__title">Контакты организации</h2>

                            <h4>Название организации</h4>

                            <div class="contacts">
                                <div class="contacts__row">
                                    <div class="contacts__item">
                                        <span class="input" v-html="activeProgram.contact ? activeProgram.contact.name : ''"></span>
                                    </div>

                                    <div class="contacts__item">
                                        <span class="input" v-html="activeProgram.contact ? activeProgram.contact.phone : ''"></span>
                                    </div>
                                </div>
                                <div class="contacts__row">
                                    <div class="contacts__item">
                                        <span class="input" v-html="activeProgram.contact ? activeProgram.contact.address : ''"></span>
                                    </div>

                                    <div class="contacts__item">
                                        <span class="input" v-html="activeProgram.contact ? activeProgram.contact.link : ''"></span>
                                    </div>
                                </div>
                                <div class="contacts__row" v-if="activeProgram.program_link">
                                    <div class="contacts__item">
                                        <span class="input" v-html="activeProgram.program_link"></span>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <form class="program__form" autocomplete="off" @submit.prevent="editItem" :key="activeProgram.id" v-else>
                    <header class="program__head">
                        <h2 class="dialog__title">{{ mode === 'interrelations' ? 'Образовательная программа' : 'Редактировать образовательную программу' }}</h2>
                    </header>

                    <div class="program__content">
                        <section class="program__section">
                            <h2 class="program__title">Основная информация</h2>

                            <input type="text" name="name" class="input" placeholder="Название" :readonly="mode === 'interrelations' || read" :value="activeProgram.name" required>

                            <textarea name="description" class="textarea mt-8" placeholder="Краткое описание" :readonly="mode === 'interrelations' || read" v-html="activeProgram.description"></textarea>

                            <v-select v-if="!mode === 'interrelations'" class="select mt-8" placeholder="Форма обучения" label="name" name="education_form_id" :clearable="false" :options="educationForms" v-model="editSelect">
                                <template #search="{attributes, events}">
                                    <input
                                        class="vs__search"
                                        v-bind="attributes"
                                        v-on="events"
                                        :required="!editSelect"
                                    />
                                </template>
                                <template #no-options="{ search, searching, loading }">
                                    {{ SELECT_NOT_FOUND }}
                                </template>
                                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes">
                                        <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                    </span>
                                </template>
                            </v-select>

                            <input v-if="mode === 'interrelations'" type="text" name="education_form_id" class="input mt-8" placeholder="Форма обучения" :readonly="mode === 'interrelations' || read" :value="editSelect.name" required>
                        </section>

                        <section class="program__section">
                            <h2 class="program__title">Контакты организации</h2>

                            <h4>Название организации</h4>

                            <div class="contacts">
                                <div class="contacts__row">
                                    <div class="contacts__item">
                                        <input type="text" name="contact_name" class="input" placeholder="Название организации" :value="activeProgram.contact ? activeProgram.contact.name : ''" :readonly="mode === 'interrelations' || read" required>
                                    </div>

                                    <div class="contacts__item">
                                        <masked-input name="contact_phone" mask="\+\7 (111) 111-11-11" class="input" placeholder="Телефон" :value="activeProgram.contact ? activeProgram.contact.phone : ''" :readonly="mode === 'interrelations' || read" required />
                                    </div>
                                </div>
                                <div class="contacts__row">
                                    <div class="contacts__item">
                                        <input type="text" name="contact_address" class="input" placeholder="Адрес организации" :value="activeProgram.contact ? activeProgram.contact.address : ''" :readonly="mode === 'interrelations' || read" required>
                                    </div>

                                    <div class="contacts__item">
                                        <input type="text" name="contact_link" class="input" placeholder="Ссылка на сайт" :value="activeProgram.contact ? activeProgram.contact.link : ''" :readonly="mode === 'interrelations' || read" required>
                                    </div>
                                </div>
                                <div class="contacts__row">
                                    <div class="contacts__item">
                                        <input type="text" name="program_link" class="input" placeholder="Ссылка на детальную страницу о программе" :value="activeProgram.program_link" :readonly="mode === 'interrelations' || read">
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <footer v-if="!mode === 'interrelations' && !read" class="dialog-programs__footer">
                        <button type="submit" class="btn btn_primary ml-auto">
                            Обновить программу
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MaskedInput from 'vue-masked-input';

import constants from '@/constants.js';
import dialog from '@/mixins/dialog';
import SelectorBtn from '@/components/SelectorBtn';

import { mergeArrsByKey } from '@/helpers';

const initialData = () => {
    return {
        activeProgram: null,
        createEntity: false,
        editEntity: false,
        editSelect: null,
        select: null,
        selection: [],
        accordionOptionsForBtn: [
            {
                name: 'Удалить',
                warning: true,
                callback: 'deleteItem'
            }
        ]
    }
}

export default {
    mixins: [ dialog ],
    components: {
        MaskedInput,
        SelectorBtn
    },
    props: {
        mode: {
            default: 'qualification',
            type: String
        },
        qualificationId: {
            type: Number,
            required: true
        },
        qualificationFromId: {
            type: Number
        },
        trainingId: {
            type: Number
        },
        read: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return initialData();
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_PROGRAMS_BY_QUALIFICATION',
            'LOAD_TRAININGS',
            'LOAD_INTERRELATIONS_BY_QUALIFICATION',
            'CREATE_PROGRAM',
            'DELETE_PROGRAM',
            'UPDATE_PROGRAM',
            'UPDATE_TRAININGS',
            'UPDATE_PROGRAMS_BY_INTERRELATIONS',
            'UPDATE_PROGRAMS_BY_QUALIFICATION'
        ]),
        ...mapActions('listsForEditor', [
            'LOAD_EDUCATION_FORMS'
        ]),
        ...mapMutations('editor', ['GROUP_QUALIFICATIONS', 'SET_QUALIFICATIONS']),

        async closeDialog() {
            if (this.mode === 'qualification') {
                const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
                await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualificationId ? Object.assign(qualification, { 'education_programs': this.programsByQualification.length }) : qualification))
                this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
            }

            this.elDialogs.programs = false;

            Object.assign(this.$data, initialData());
        },
        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },
        async deleteItem({ id }) {
            await this.DELETE_PROGRAM(id)
            await this.LOAD_PROGRAMS_BY_QUALIFICATION(this.qualificationId);
            this.selection = this.selection.filter(el => el !== id)
            this.activeProgram = null
        },
        createProgram() {
            this.createEntity = true;
            this.showItem = false;
        },
        async createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                contact: {},
                education_form_id: this.select.id,
                qualification_id: this.qualificationId
            };

            for (const pair of formData.entries()) {
                if (!pair[0].startsWith('contact')) {
                    params[pair[0]] = pair[1];
                } else {
                    params.contact[pair[0].slice(pair[0].indexOf('_') + 1)] = pair[1];
                }
            }

            const newProgram = await this.CREATE_PROGRAM(params);
            this.selection.push(newProgram.id)
            
            e.target.reset();
        },
        async editItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                id: this.activeProgram.id,
                contact: {},
                education_form_id: this.editSelect.id,
                // qualification_id: this.qualificationId
            };

            for (const pair of formData.entries()) {
                if (!pair[0].startsWith('contact')) {
                    params[pair[0]] = pair[1];
                } else {
                    params.contact[pair[0].slice(pair[0].indexOf('_') + 1)] = pair[1];
                }
            }

            const program = await this.UPDATE_PROGRAM(params);
            this.LOAD_PROGRAMS_BY_QUALIFICATION(this.qualificationId);

            this.activeProgram = program;
        },
        editProgram(program) {
            this.createEntity = false;
            this.showItem = true;
            this.activeProgram = program;
            this.editSelect = this.educationForms.find(el => el.id === this.activeProgram.education_form_id);
        },
        async handleOpen() {
            this.LOAD_PROGRAMS_BY_QUALIFICATION(this.qualificationId);
            if (this.educationForms.length === 0) this.LOAD_EDUCATION_FORMS();
            if (this.mode === 'interrelations') {
                await this.LOAD_TRAININGS(this.trainingId)
                console.log(this.trainings.education_programs);
                this.selection = this.trainings.education_programs.map((item) => item.id)
            } else if (this.mode === 'qualification') {
                this.selection = this.programsByQualification.map((item) => item.id)
            }
        },
        async submitSelected() {
            if (this.mode === 'qualification') {
                const ids = [...new Set(this.selection, ...this.programsByQualification.map((item) => item.id))];

                await this.UPDATE_PROGRAMS_BY_QUALIFICATION({
                    id: this.qualificationId,
                    ids
                });
            } else if (this.mode === 'interrelations') {
                const ids = [...new Set(this.selection)];

                const params = {
                    trainingId: this.trainingId,
                    ids
                }

                await this.UPDATE_TRAININGS(params)
                await this.LOAD_INTERRELATIONS_BY_QUALIFICATION(this.qualificationFromId)
            }

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['programsByQualification', 'trainings', 'groupItemsBy', 'qualifications', 'orkInfo']),
        ...mapState('listsForEditor', ['educationForms']),
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
